"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactBemHelper = _interopRequireDefault(require("react-bem-helper"));
var _dataTestAttributeHelper = require("../../../helpers/dataTestAttributeHelper");
require("./APLabelWithText.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = new _reactBemHelper["default"]({
  name: 'ap-label-with-text',
  outputIsString: true
});
var LabelWithText = function LabelWithText(props) {
  var label = props.label,
    text = props.text,
    customClass = props.customClass,
    classModifiers = props.classModifiers;
  var customClasses = new _reactBemHelper["default"]({
    name: customClass,
    outputIsString: true
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(baseClasses(), customClasses('lwt-container', classModifiers))
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])('ap--label', baseClasses('label'), customClasses('lwt-label', classModifiers))
  }, label), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(baseClasses('text'), customClasses('lwt-text', classModifiers)),
    "data-test": (0, _dataTestAttributeHelper.getDataTestAttribute)(props, 'label')
  }, text));
};
LabelWithText.propTypes = {
  label: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object]),
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].objectOf(_propTypes["default"].bool)]),
  dataTest: _propTypes["default"].string
};
LabelWithText.defaultProps = {
  customClass: 'custom-label-with-text'
};
var _default = exports["default"] = LabelWithText;